<template>
  <div>
    <bTable :thData="thData" :trData="currentPageData" :loading="loading" :tip="$t('records.transfer.noFund')" :src="src" :params="params" @size-change="sizeChange"
      @current-change="currentChange">
    </bTable>
  </div>
</template>

<script>
import tableTh from '../../table-config/transfer'

export default {
  props: ['datas', 'loading', 'count'],
  data () {
    return {
      name: 'transfer',
      currentPageData: [],
      tip: 'noFund',
      src: require('@/assets/images/noFundertransfer.png'),
      params: {
        selection: false,
        pageSizes: [3, 5, 10, 15],
        pageSize: 15,
        total: 0,
        totalPage: 1
      }
    }
  },
  methods: {
    pageCount (totalnum, limit) {
      return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1)
        : (totalnum / limit))) : 0
    },
    sizeChange (val) {
      this.params.pageSize = val
      this.params.totalPage = 1
      // this.$emit('pageSize','deposit',val)
      this.$emit('totalPage-pageSize', [1, this.params.pageSize])
    },
    setPageSize () {
      this.params.totalPage = 1
      this.$emit('totalPage-pageSize', [1, this.params.pageSize])
    },
    currentChange (val) {
      this.params.totalPage = val
      this.$emit('totalPage-pageSize', [this.params.totalPage, this.params.pageSize])
    },
    computeCurrentPageData (val) {
      this.params.total = this.datas.transferData.length
      var computeData = this.Util.getCurrentPageData(
        this.params.totalPage,
        this.params.pageSize,
        this.datas.transferData
      )
      // 计算总页数
      this.totalPage = this.pageCount(length, this.params.pageSize)
      this.currentPageData = computeData
    }
  },
  mounted () {
    // this.computeCurrentPageData();
  },
  computed: {
    thData () {
      let arr = []
      for (let i = 0; i < tableTh.length; i++) {
        let item = {
          label: this.$t('records.transfer.' + tableTh[i].name),
          name: tableTh[i].name, // $t('setting.phoneNum')
          width: tableTh[i].width,
          sortable: tableTh[i].sortable
        }
        arr.push(item)
      }
      return arr
    }
  },
  components: {},
  watch: {
    'count.transfer': function (val) {
      this.params.total = val
    },
    'datas.transferData': function (val) {
      this.currentPageData = val
      // this.computeCurrentPageData();
    }
    // "params.totalPage": function () {
    //   this.computeCurrentPageData();
    // },
    // "params.pageSize": function () {
    //   this.computeCurrentPageData();
    // },
  }
}

</script>

<style>
</style>
